import { render, staticRenderFns } from "./RPTableUserList.vue?vue&type=template&id=2f87503a&style=height%3A%20100%25%3B"
import script from "./RPTableUserList.vue?vue&type=script&lang=js"
export * from "./RPTableUserList.vue?vue&type=script&lang=js"
import style0 from "./RPTableUserList.vue?vue&type=style&index=0&id=2f87503a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports